import React, {createContext, useState, useCallback, useEffect, useMemo, useContext} from 'react';
import {userService} from '../services/UserService';

export const UserSearchContext = createContext();

export const UserSearchProvider = props => {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [searchTerm, setSearchTerm] = useState();
  const [err, setErr] = useState();

  const searchUsers = useCallback(() => {
    setIsLoading(true);
    userService
      .searchUsers(searchTerm)
      .then(res => {
        setResults(res);
        setIsLoading(false);
      })
      .catch(err => setErr(err));
  }, [searchTerm]);

  useEffect(() => {
    // init search users
    if (searchTerm) {
      if (searchTerm !== '') {
        searchUsers();
      }
    }
  }, [searchTerm, searchUsers]);

  const values = useMemo(
    () => ({results, isLoading, searchTerm, setSearchTerm, err}),
    [results, isLoading, searchTerm, err]
  );

  return <UserSearchContext.Provider value={values}>{props.children}</UserSearchContext.Provider>;
};

export const useUserSearch = () => {
  const context = useContext(UserSearchContext);

  if (context === undefined) {
    throw new Error('useUsers must be used within a UserProvider component.');
  }

  return context;
};
